import { forwardRef } from 'react'
import { MaterialSymbol, MaterialSymbolProps } from '../material-symbols/src/index'


export type Icon3Props = {
  icon: MaterialSymbolProps['icon']
  size?: MaterialSymbolProps['size']
  // fill?: MaterialSymbolProps['fill']
  color?: MaterialSymbolProps['color']
  weight?: MaterialSymbolProps['weight']
  // grade?: MaterialSymbolProps['grade']
  style?: MaterialSymbolProps['style']
  // opticalSize?: MaterialSymbolProps['opticalSize']
  className?: MaterialSymbolProps['className']
}

export const Icon = forwardRef<HTMLSpanElement, Icon3Props>((props, ref) => {
  return <MaterialSymbol {...props} ref={ref} />
})
